import React from 'react'

import CommonFooter from '../CommonFooter'
import { Route, Switch } from 'react-router-dom'
import QueryCom from './query'
import ResetCom from './reset'
import SuccessCom from './success'
import './index.less'

const RetrievePassword = () => {
  return (
    <div className="wrap">
      <div className='wrap-mask' style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/login-bg.png)`
      }}>
        <div className='logo'>
          <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt='logo' />
        </div>
        <Switch>
          <Route path="/retrieve/query" component={QueryCom}></Route>
          <Route path="/retrieve/reset" component={ResetCom}></Route>
          <Route path="/retrieve/success" component={SuccessCom}></Route>
        </Switch>
        <div className="footer-container">
          <CommonFooter color="blue" />
        </div>
      </div>
    </div>
  )
}

export default RetrievePassword
